import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  TextField,
  Button,
  Snackbar,
  Alert,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import adminAuth from "../../components/adminAuth";
import axios from "axios";
import AddUser from "./AddUser";
import { Stack } from "@mui/system";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { setShowAlert, updateCreditStatus } from "../../store/addUserSlice";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";



const Container = styled.div`
  display: flex;
  justify-content: center;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  border-radius: 5px;
  width: 70%;

  & > * {
    margin-bottom: 1rem;
  }
`;

const Title = styled.h1`
  font-size: 1.5rem;
  margin-bottom: 2rem;
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const SendMail = () => {
  const [to, setTo] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [attachment, setAttachment] = useState("");
  const [data, setData] = useState("");
  const [lodar, setLodar] = useState(false);
  const [flag, setFlag] = useState(false);
  const [sendTo, setSendTo] = useState("testing");

  const handleEditorChange = (value) => {
    setBody(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Email sent with attachment:", {
      to,
      subject,
      body,
      attachment,
    });
    const allData = new FormData();
    allData.append("file", attachment);
    allData.append("subject", subject);
    allData.append("body", body);
    setData(allData);

    // Reset form
    setTo("");
    setSubject("");
    setBody("");
    setAttachment(null);
  };

  const handleAttachmentChange = (e) => {
    setAttachment(e.target.files[0]);
  };

  useEffect(() => {
    if (data && sendTo === "client") {
      setLodar(true);
      axios.post("/getdetails", data).then((response) => {
        console.log(response);
        if (response.data === "testing complete") {
          setFlag(true);
        }
        setLodar(false);
      });
    }else if(data && sendTo === "testing"){
      setLodar(true);
      axios.post("/getdetailstest", data).then((response) => {
        console.log(response);
        if (response.data === "testing complete") {
          setFlag(true);
        }
        setLodar(false);
      });
    }
  }, [data]);

  const handleClose = () => {
    setFlag(false);
  };

  return lodar ? (
    <div style={bgStyles}></div>
  ) : (
    <>
      <Stack sx={{ m: 4 }} direction={"row"} justifyContent={"space-between"}>
        <Typography variant="h5" >
          Compose Email
        </Typography>
        <Box sx={{ minWidth: 180 }}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Sent To</InputLabel>
            <Select
            sx={{fontSize:'small'}}
            size="small"
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={sendTo}
              label="Sent To:"
              onChange={(e) => setSendTo(e.target.value)}
            >
              <MenuItem value={"testing"}>For Testing</MenuItem>
              <MenuItem value={"client"}>Send To Client</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Stack>
      <Container>
        <Form onSubmit={handleSubmit}>
          {/* <TextField
          label="To"
          value={to}
          onChange={handleToChange}
          error={toError !== null}
          helperText={toError}
          variant="outlined"
          required
        /> */}
          <TextField
            label="Subject"
            autoComplete="off"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            variant="outlined"
            required
          />
          {/* <TextField
            autoComplete="off"
            label="Body"
            id="filled-multiline-static"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            variant="outlined"
            multiline
            rows={6}
            required
          /> */}

          <ReactQuill
            style={{ minHeight: "30vh" }}
            value={body}
            onChange={handleEditorChange}
            modules={{
              toolbar: [
                [{ header: [1, 2, false] }],
                ["bold", "italic", "underline"],
                ["link"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["image"],
              ],
            }}
            formats={[
              "header",
              "bold",
              "italic",
              "underline",
              "list",
              "bullet",
              "link",
              "image",
            ]}
          />

          {/* <AttachmentInput
            type="file"
            id="attachment"
            accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip,.rar"
            onChange={handleAttachmentChange}
          />
          <AttachmentLabel htmlFor="attachment">
            Attach file
            {attachment && <AttachmentName>{attachment.name}</AttachmentName>}
          </AttachmentLabel> */}

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              border: "1px dashed black",
              padding: 1,
              mt: 2,
            }}
          >
            <Typography color={"#767676"}>
              {attachment ? attachment.name : "Attach file"}
            </Typography>

            <div style={styles}>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  color: "white",
                  backgroundColor: "#185cb7",
                }}
                className="custom-file-upload"
              >
                <input
                  type="file"
                  style={{ display: "none" }}
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip,.rar"
                  multiple
                  onChange={handleAttachmentChange}
                />
                <Icon
                  icon="material-symbols:cloud-upload"
                  color="white"
                  width="25"
                  height="25"
                  sx={{ marginRight: 5 }}
                />
                Attach
              </label>
            </div>
          </Box>
          <Actions>
            <Button
              type="submit"
              variant="contained"
              sx={{ width: "100%" }}
              color="primary"
            >
              Send
            </Button>
          </Actions>
        </Form>

        <Snackbar
          open={flag}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          sx={{
            background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
            color: "white",
          }}
        >
          <Alert
            onClose={handleClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            Successfully Sent !
          </Alert>
        </Snackbar>
      </Container>
    </>
  );
};

export default adminAuth(SendMail);
const bgStyles = {
  backgroundImage: `url(/prelodar.gif)`,
  height: "90vh",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
};

const styles = {
  fontFamily: "sans-serif",
  textAlign: "center",
  display: "flex",
};
